<template>
  <v-container>
    <v-sheet outlined>
      <v-data-table
        :headers="headers"
        :items="eventItems"
        tableClasses="item-table border"
        disable-pagination
        responsive
        hide-default-footer
        fixed-header
        ref="baseTable"
      >
        <template v-slot:[`item.occuredTimeUtc`]="{ item }">
          {{ jalaliDate(item.occuredTimeUtc) }}
        </template>
        <template v-slot:[`item.tradeRequestEventAction`]="{ item }">
          {{ eventActionDisplayName(item.tradeRequestEventAction) }}
        </template>
        <template v-slot:[`item.display`]="{ item }">
          <v-btn icon title="مشاهده" color="primary" @click="displayItem(item)">
            <v-icon> mdi-eye </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-sheet>
    <div class="text-center pt-5">
      <v-row>
        <v-col cols="12" sm="2" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="10" md="10">
          <v-pagination
            circle
            v-model="pageNumber"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <v-row class="my-4">
      <v-spacer></v-spacer>
      <v-btn class="mx-2" color="error" @click="closeForm">بستن</v-btn>
    </v-row>
    <v-dialog v-model="eventModal" v-if="eventModal" max-width="800px">
      <v-card>
        <v-card-title> جزییات سابقه </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="6" md="4">
              <label> رخداد : </label>
              <strong>
                {{
                  eventActionDisplayName(selectedEvent.tradeRequestEventAction)
                }}
              </strong>
            </v-col>
            <v-col cols="6" md="4">
              <label>رخداد توسط: </label>
              <strong>{{
                selectedEvent.occurredByFullName
                  ? selectedEvent.occurredByFullName
                  : 'وارد نشده'
              }}</strong>
            </v-col>
            <v-col cols="6" md="4">
              <label> تاریخ رخداد : </label>
              <strong>
                {{ jalaliDate(selectedEvent.occuredTimeUtc) }}
              </strong>
            </v-col>
            <v-col cols="12">
              <label>توضیحات: </label>
              <strong>{{ selectedEvent.description }}</strong>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="mx-2"
            color="error"
            @click="
              eventModal = false;
              selectedEvent = null;
            "
            >بستن</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
const tradeRequestsRepository = () => RepoFactory.get('tradeRequests');
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
import qs from "qs";
export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  watch: {
    itemsPerPage() {
      this.pageNumber = 1;
      this.getData();
    },
    pageNumber() {
      this.getData();
    },
  },
  data() {
    return {
      selectedEvent: null,
      eventModal: false,
      tradeEventActionsList: [],
      id: null,
      pageNumber: 1,
      itemsPerPage: 10,
      pageCount: 0,
      eventItems: [],
      headers: [
        {
          value: 'tradeRequestEventAction',
          text: 'رخداد',
          sortable: true,
        },
        {
          value: 'occuredTimeUtc',
          text: 'تاریخ رخداد',
          sortable: true,
        },

        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },
        {
          value: 'display',
          text: 'مشاهده',
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.tradeEventActions();
    this.getData();
  },
  computed: {
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
  },
  methods: {
    eventActionDisplayName(title) {
      if (this.tradeEventActionsList.length) {
        let result = this.tradeEventActionsList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeEventActions() {
      this.tradeEventActionsList = this.getEnumByTitle(
        'TradeRequestEventActionType'
      );
    },
    getData() {
      let params = {
        tradeRequestId: this.id,
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
      };
      params.Orders = [
        {
          column: 'createdTimeUtc',
          order: 'Descending',
        },
      ];
      const loader = this.$loading.show();

      tradeRequestsRepository()
        .getTradeRequestEvents(this.tradeBaseUrl, {}, params, (params) => {
          return qs.stringify(params, { allowDots: true });
        })
        .then((res) => {
          this.eventItems = res.data.list;
          this.pageCount = Math.ceil(res.data.totalCount / this.itemsPerPage);
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },

    displayItem(item) {
      const loader = this.$loading.show();
      let id = item.id;
      let params = { tradeRequestId: this.id };
      tradeRequestsRepository()
        .getTradeRequestEventsById(id, this.tradeBaseUrl, {}, params)
        .then((res) => {
          this.selectedEvent = res.data;
          this.eventModal = true;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    closeForm() {
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$router.push({ path: '/trade-request' });
    },
  },
};
</script>

<style></style>
